import { PartnerWorkerProfile } from 'api/services/partner-worker/partner-worker-profile.schema';
import { useTranslation } from 'react-i18next';
import { DetailColumn, DetailSection } from 'redesign';
import { formatDateFromString } from 'shared/utils/formatting';

type Props = {
  data: PartnerWorkerProfile;
};

export const PartnerWorkerInformationTab = ({ data }: Props) => {
  const { t } = useTranslation('all-platforms-common');

  const columns: DetailColumn[] = [
    {
      items: [
        {
          title: t('worker_data.first_name', { ns: 'all-platforms-common' }),
          value: data.firstName,
        },
        {
          title: t('worker_data.email', { ns: 'all-platforms-common' }),
          value: data.email,
        },
      ],
    },
    {
      items: [
        {
          title: t('worker_data.infix', { ns: 'all-platforms-common' }),
          value: data.infix,
        },
        {
          title: t('worker_data.phone', { ns: 'all-platforms-common' }),
          value: data.phone,
        },
      ],
    },
    {
      items: [
        {
          title: t('worker_data.last_name', { ns: 'all-platforms-common' }),
          value: data.lastName,
        },
      ],
    },
    {
      items: [
        {
          title: t('worker_data.salary_scale', { ns: 'all-platforms-common' }),
          value: data.salaryScale?.toString() ?? null,
        },
      ],
    },
    {
      items: [
        {
          title: t('worker_data.salary_step', { ns: 'all-platforms-common' }),
          value: data.salaryStep?.toString() ?? null,
        },
      ],
    },
    {
      items: [
        {
          title: t('worker_data.start_date', { ns: 'all-platforms-common' }),
          value: data.startDate ? formatDateFromString(data.startDate) : null,
        },
      ],
    },
    {
      items: [
        {
          title: t('worker_data.end_date', { ns: 'all-platforms-common' }),
          value: data.endDate ? formatDateFromString(data.endDate) : null,
        },
      ],
    },
    {
      items: [
        {
          title: t('worker_data.contract_hours', { ns: 'all-platforms-common' }),
          value: data.contractHours?.toString() ?? null,
        },
      ],
    },
  ];

  return <DetailSection columns={columns} />;
};
